module.exports = __webpack_public_path__ + "img/team-6-modal.62c1d6c2.jpg";